<template>
    <section class="justify-content-center mb-4">
        <table style="width:100%;" class="mb-3">
            <thead>
                <tr>
                    <th  class="px-2">
                            <input type="text"
                                style="font-size:11px; border:1px solid #3A9AF3; border-radius:5px; color:#3A9AF3; width:100%;"
                                
                                 :placeholder="__('traductionview.searchpointcontact')"
                                v-model="filtername"
                                @change="onFilterNameChange()">
                    </th>
                    <th  class="px-2">
                            <input type="text"
                                style="font-size:11px; border:1px solid #3A9AF3; border-radius:5px; color:#3A9AF3; width:100%;"
                                :placeholder="__('traductionview.searchcompany')"
                                v-model="filtercompany"
                                @change="onFilterCompanyChange()">
                        </th>
                </tr>
            </thead>
        </table>
        <div class="col-md-12 mx-auto dashboardstyle pt-0">
            <table class="mx-auto text-center abc-table" style="width:100%;">
                <thead class="abc-title-table">
                    <tr style="border-bottom:solid 1px #3A9AF3;">
                        <th
                            class="py-3"
                            style="vertical-align: middle; width: 25%;"
                        >
                            {{ __("traductionview.nomnom") }}
                            <button
                                style="text-align:center;"
                                type="button"
                                class="btn-sort"
                                aria-label="Tri ascendant"
                                v-on:click="projectSortAsc"
                            >
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="9"
                                    height="9"
                                    fill="rgb(107, 107, 107)"
                                    class="bi bi-caret-up-fill"
                                    viewBox="0 0 16 16"
                                >
                                    <path
                                        d="m7.247 4.86-4.796 5.481c-.566.647-.106 1.659.753 1.659h9.592a1 1 0 0 0 .753-1.659l-4.796-5.48a1 1 0 0 0-1.506 0z"
                                    />
                                </svg>
                            </button>
                            <button
                                style="text-align:center"
                                type="button"
                                class="btn-sort"
                                aria-label="Tri descendant"
                                v-on:click="projectSortDsc"
                            >
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="9"
                                    height="9"
                                    fill="rgb(107, 107, 107)"
                                    class="bi bi-caret-down-fill"
                                    viewBox="0 0 16 16"
                                >
                                    <path
                                        d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z"
                                    />
                                </svg>
                            </button>
                        </th>
                        <th style="vertical-align: middle; width: 25%;">
                            {{ __("traductionview.titre") }}
                            <button
                                style="text-align:center;"
                                type="button"
                                class="btn-sort"
                                aria-label="Tri ascendant"
                                v-on:click="titleSortAsc"
                            >
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="9"
                                    height="9"
                                    fill="rgb(107, 107, 107)"
                                    class="bi bi-caret-up-fill"
                                    viewBox="0 0 16 16"
                                >
                                    <path
                                        d="m7.247 4.86-4.796 5.481c-.566.647-.106 1.659.753 1.659h9.592a1 1 0 0 0 .753-1.659l-4.796-5.48a1 1 0 0 0-1.506 0z"
                                    />
                                </svg>
                            </button>
                            <button
                                style="text-align:center"
                                type="button"
                                class="btn-sort"
                                aria-label="Tri descendant"
                                v-on:click="titleSortDsc"
                            >
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="9"
                                    height="9"
                                    fill="rgb(107, 107, 107)"
                                    class="bi bi-caret-down-fill"
                                    viewBox="0 0 16 16"
                                >
                                    <path
                                        d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z"
                                    />
                                </svg>
                            </button>
                        </th>
                        <th style="vertical-align: middle; width: 25%;">
                            {{ __("traductionview.entrepri") }}
                        </th>
                        <th style="vertical-align: middle; width: 25%;">
                            {{ __("traductionview.payspresence") }}
                        </th>
                        <th style="vertical-align: middle; width: 25%;"></th>
                    </tr>
                </thead>
                <tbody
                    id="ongoingproject"
                    style="font-size: 9px; overflow:auto; display:block; max-height:600px;"
                >
                    <tr
                        v-for="(customer, index) in customs"
                        :key="index"
                        style="border-bottom:solid 1px rgb(206,206,206);"
                    >
                        <td style="vertical-align: middle; width: 25%;">
                            {{ customer.firstname }} {{ customer.lastname }}
                        </td>
                        <td style="vertical-align: middle; width: 25%;">
                            {{ customer.title }}
                        </td>
                        <td style="vertical-align: middle; font-weight: bold">
              <a
                v-if="customer.id !== user.id"
                :href="`/${customer.id}/impersonate`"
                class="btn btn-warning btn-sm triggerspinner"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  class="bi bi-eye"
                  viewBox="0 0 16 16"
                >
                  <path
                    d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8zM1.173 8a13.133 13.133 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13.133 13.133 0 0 1 14.828 8c-.058.087-.122.183-.195.288-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5c-2.12 0-3.879-1.168-5.168-2.457A13.134 13.134 0 0 1 1.172 8z"
                  />
                  <path
                    d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5zM4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0z"
                  />
                </svg>
              </a>
            </td>
                   <td class="py-3" style="vertical-align: middle; width: 9%;">
                            {{ customer.country.name }}
                        </td>
                        <td class="py-3" style="vertical-align: middle; width: 9%;">
                            <div v-for="(country, i) in customer.countries" :key="i">
                                {{ country.name }}
                            </div>
                        </td>
                        <td style="vertical-align: middle; width: 25%;">
                            <div
                                v-for="(country,
                                i) in customer.country_presence"
                                :key="i"
                            >
                                {{ country.name }}
                            </div>
                        </td>
                        <td style="vertical-align: middle; width: 25%;">
                            <a
                                :href="
                                    '/app/home/manager/select_country/' +
                                        customer.id
                                "
                                class="btn btn-abc"
                                style="padding: 10px;"
                            >
                                <p class="mb-0">
                                    {{ __("traductionview.editpayss") }}
                                </p>
                            </a>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </section>
</template>

<script>
export default {
    props: ["customers", "country", "user", "token", "route"],

    data() {
        return {
            customs: [],
            filtername: "",
            filterproject: "",
            filtercompany: "",
            filterstatus: ""
        };
    },

    mounted() {
        this.customers.forEach(customer => {
            this.customs.push(customer);
        });
        console.log(this.customers);
    },

    methods: {
        onFilterNameChange() {
            this.customs = [];
            this.customers.forEach(customer => {
                var search = customer.firstname.toLowerCase();
                if (search.includes(this.filtername.toLowerCase())) {
                    this.customs.push(customer);
                }
            });
        },
        onFilterCompanyChange() {
            this.customs = [];
            this.customers.forEach(customer => {
                var search = customer.company.toLowerCase();
                if (search.includes(this.filtercompany.toLowerCase())) {
                    this.customs.push(customer);
                }
            });
        },
        projectSortAsc() {
            this.customs = this.customs.sort(function(a, b) {
                if (a.firstname < b.firstname) {
                    return -1;
                } else if (a.firstname > b.firstname) {
                    return 1;
                } else {
                    return 0;
                }
            });
        },
        projectSortDsc() {
            this.customs = this.customs.sort(function(a, b) {
                if (a.firstname > b.firstname) {
                    return -1;
                } else if (a.firstname < b.firstname) {
                    return 1;
                } else {
                    return 0;
                }
            });
        },
        companySortAsc() {
            this.customs = this.customs.sort(function(a, b) {
                if (a.company < b.company) {
                    return -1;
                } else if (a.company > b.company) {
                    return 1;
                } else {
                    return 0;
                }
            });
        },
        companySortDsc() {
            this.customs = this.customs.sort(function(a, b) {
                if (a.company > b.company) {
                    return -1;
                } else if (a.company < b.company) {
                    return 1;
                } else {
                    return 0;
                }
            });
        },
        titleSortAsc() {
            this.customs = this.customs.sort(function(a, b) {
                if (a.title < b.title) {
                    return -1;
                } else if (a.title > b.title) {
                    return 1;
                } else {
                    return 0;
                }
            });
        },
        titleSortDsc() {
            this.customs = this.customs.sort(function(a, b) {
                if (a.title > b.title) {
                    return -1;
                } else if (a.title < b.title) {
                    return 1;
                } else {
                    return 0;
                }
            });
        }
    }
};
</script>
